import { RiWifiOffLine, RiDeviceLine } from "react-icons/ri";
import { TbReportAnalytics, TbBuildingFactory2 } from "react-icons/tb";
import "./index.css"

export function Features() {
  const items = [
    {
      icon: <RiWifiOffLine size={28} />,
      title: "Works Anywhere",
      text:
        "Clock-ins are stored on the device and sync to the cloud when a connection is available.",
      tag: "Offline-first",
      tone: "blue",
    },
    {
      icon: <RiDeviceLine size={28} />,
      title: "Mobile & Tablet Ready",
      text:
        "Android phones, iPads and tablets with supported fingerprint readers.",
      tag: "Android • iOS",
      tone: "purple",
    },
    {
      icon: <TbReportAnalytics size={28} />,
      title: "Payroll-Ready Reports",
      text:
        "Export timesheets or integrate with payroll to reduce admin and errors.",
      tag: "CSV • API",
      tone: "green",
    },
    {
      icon: <TbBuildingFactory2 size={28} />,
      title: "Built for SA Conditions",
      text:
        "Dust-, splash- and shock-tolerant device options with long battery life.",
      tag: "Rugged",
      tone: "orange",
    },
  ];

  return (
    <section id="features" className="section">
      <div className="container">
        <h2 className="section__title">Why teams choose our offline system</h2>

        <div className="featuregrid">
          {items.map(({ icon, title, text, tag, tone }) => (
            <article key={title} className={`featurecard featurecard--${tone}`}>
              <div className="featurecard__icon">{icon}</div>
              <h3 className="featurecard__title">{title}</h3>
              <p className="featurecard__text">{text}</p>
              <span className="chip">{tag}</span>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
